const CHANNEL_NAME = "sos-auth-channel";
const LOGOUT_KEY = "sos-logout";

const channel =
  "BroadcastChannel" in window
    ? new BroadcastChannel(CHANNEL_NAME)
    : null;

export const logoutEverywhere = () => {
  // Clear authentication
  localStorage.removeItem("aurelia_token");

  // Tell other tabs
  if (channel) {
    channel.postMessage({ type: "LOGOUT" });
  }

  // localStorage fallback
  localStorage.setItem(LOGOUT_KEY, Date.now().toString());
  localStorage.removeItem(LOGOUT_KEY);

  // Current tab
  window.location.href = "/login";
};

export const initializeAuthSync = (logout) => {
  // BroadcastChannel
  if (channel) {
    channel.onmessage = (event) => {
      if (event.data?.type === "LOGOUT") {
        logout();
      }
    };
  }

  // localStorage fallback
  const handleStorage = (event) => {
    if (event.key === LOGOUT_KEY) {
      logout();
    }
  };
  window.addEventListener("storage", handleStorage);

  return () => {
    window.removeEventListener("storage", handleStorage);
  };
};
